import { useQuery } from '@tanstack/react-query';
import type { ProductKnowledgeArticle } from '../types';

export default function useProductKnowledgeArticle(articleId: string | null) {
  return useQuery<ProductKnowledgeArticle>({
    queryKey: ['admin', 'product-knowledge', articleId],
    enabled: articleId !== null,
  });
}
